export const FIELD_W = 53.33;
export const FIELD_L = 120;
export const CENTER_X = FIELD_W / 2;

export function viewWindow(los) {
  const top = Math.max(0, Math.min(los - 26, FIELD_L - 40));
  return { x: -2.5, y: top, w: FIELD_W + 5, h: 40 };
}

export function clampPoint(pt, win) {
  return {
    x: Math.round(Math.min(FIELD_W - 0.5, Math.max(0.5, pt.x)) * 10) / 10,
    y: Math.round(Math.min(win.y + win.h - 0.8, Math.max(win.y + 0.8, pt.y)) * 10) / 10,
  };
}

const range = (a, b, s) => { const o = []; for (let v = a; v <= b; v += s) o.push(v); return o; };
const yardNumber = (y) => Math.min(y - 10, 110 - y);
const W = "rgba(255,255,255,";

function Lines() {
  return (
    <>
      {range(10, 110, 5).map((y) => (
        <line key={`l${y}`} x1={0} x2={FIELD_W} y1={y} y2={y} stroke={`${W}0.85)`} strokeWidth={y === 10 || y === 110 ? 0.35 : 0.15} />
      ))}
      {range(11, 109, 1).filter((y) => y % 5).map((y) => (
        <g key={`h${y}`} stroke={`${W}0.55)`} strokeWidth={0.12}>
          <line x1={0.3} x2={1.1} y1={y} y2={y} />
          <line x1={FIELD_W - 1.1} x2={FIELD_W - 0.3} y1={y} y2={y} />
          <line x1={23.2} x2={24} y1={y} y2={y} />
          <line x1={29.3} x2={30.1} y1={y} y2={y} />
        </g>
      ))}
      {range(20, 100, 10).map((y) => (
        <g key={`n${y}`} fill={`${W}0.7)`} fontSize={2.4} fontWeight={700} textAnchor="middle" dominantBaseline="middle" fontFamily="Barlow Condensed, sans-serif">
          <text x={6} y={y}>{yardNumber(y)}</text>
          <text x={FIELD_W - 6} y={y}>{yardNumber(y)}</text>
        </g>
      ))}
    </>
  );
}

function Marker({ y, color, label, dash }) {
  return (
    <g>
      <line x1={0} x2={FIELD_W} y1={y} y2={y} stroke={color} strokeWidth={0.35} strokeDasharray={dash} />
      <rect x={FIELD_W - 9.6} y={y - 1.55} width={9.2} height={1.3} rx={0.3} fill="rgba(11,21,40,0.75)" />
      <text x={FIELD_W - 5} y={y - 0.9} fill={color} fontSize={0.95} fontWeight={800} textAnchor="middle" dominantBaseline="middle">{label}</text>
    </g>
  );
}

export function FootballField({ win, los, firstDown }) {
  return (
    <g data-testid="football-field">
      <rect x={win.x} y={win.y} width={win.w} height={win.h} fill="#123F27" />
      <rect x={0} y={0} width={FIELD_W} height={FIELD_L} fill="#1E5E3A" />
      {range(10, 100, 10).map((y) => <rect key={y} x={0} y={y} width={FIELD_W} height={5} fill="#1A5534" />)}
      {[0, 110].map((y) => (
        <g key={`ez${y}`}>
          <rect x={0} y={y} width={FIELD_W} height={10} fill="#0F3822" />
          <text x={CENTER_X} y={y + 5} fill={`${W}0.3)`} fontSize={3.2} fontWeight={800} textAnchor="middle" dominantBaseline="middle" letterSpacing={1}>END ZONE</text>
        </g>
      ))}
      <Lines />
      <rect x={0} y={0} width={FIELD_W} height={FIELD_L} fill="none" stroke="#FFFFFF" strokeWidth={0.4} />
      {firstDown != null && firstDown >= 0 && <Marker y={firstDown} color="#FACC15" label="1ST DOWN" dash="1 0.5" />}
      <Marker y={los} color="#60A5FA" label="LINE OF SCRIMMAGE" />
    </g>
  );
}
